import Link from "next/link";
import Strings from "@/shared/utils/Strings.constants";
import { UIUtils } from "@/shared/utils/UIUtils";
import { SAMPLE_POLICY_URL } from "../utils/constants";

/**
 * Canada underwriting & administration disclosure content.
 * Shared by the site-header underwriter link and the Checkout step's
 * "Underwriting Requirements" terms modal so the copy stays in one place.
 */
export function CanadaUnderwriterContent() {
    const formattedPhone = UIUtils.formatPhone(Strings.PTZ_CA.PHONE_NUMBER, ".");

    return (
        <>
            <p>
                Spot Pet Insurance Programs are underwritten by Northbridge General Insurance Corporation and administrated by PTZ Insurance Services Ltd. PTZ Insurance Services
                Ltd. and Northbridge Insurance are parts of Independence Pet Group. PTZ Insurance Services Ltd. administers pet insurance policies by handling claims, billing,
                customer service, and sales. PTZ Insurance Services Ltd. is authorized to sell insurance in all 10 provinces and 3 territories.
            </p>
            <p className="font-bold">Underwriter:</p>
            <p>Northbridge General Insurance Corporation</p>
            <p>105 Adelaide Street West, Suite 700, Toronto, Ontario M5H 1P9</p>

            <Link href={SAMPLE_POLICY_URL} target="_blank" className="font-bold">
                nbfc.com
            </Link>

            <p>
                Contact PTZ Insurance Services Ltd. at{" "}
                <a href={`tel:${Strings.PTZ_CA.PHONE_NUMBER}`} className="font-bold underline">
                    {formattedPhone}
                </a>{" "}
                for more information.
            </p>
        </>
    );
}
